import { useCounter } from "utils/hooks";

export default function CounterText({ seconds: seconds }: { seconds: number }) {
  const [currCount] = useCounter(seconds, {
    startImmediately: true,
  });

  return (
    <span className="font-semibold" style={{ fontVariantNumeric: "tabular-nums" }}>
      {String(currCount)}
    </span>
  );
}
